import { MediaMetadata } from '@/context/MediaContext';

export type PlayerPosition = 'bottom-right' | 'bottom-left';

export type MediaVariant = 'video' | 'audio' | 'stream' | 'radio' | 'podcast' | 'article';

export interface PlayerState {
  isHidden: boolean;
  isMinimized: boolean;
  isAnimating: boolean;
  position: PlayerPosition;
}

export interface ViewportInfo {
  width: number;
  isMobile: boolean;
}

export interface MediaConfiguration {
  readonly defaultWidth: number;
  readonly minWidth: number;
  readonly aspectRatio: number;
  readonly displayName: string;
}

export interface MediaPlayerProps {
  isVisible: boolean;
  title: string;
  mediaVariant?: MediaVariant;
  initialPosition?: PlayerPosition;
  children: React.ReactNode;
  onClose: () => void;
}

export interface VidstackPlayerProps {
  children?: React.ReactNode;
  source: string;
  metadata?: MediaMetadata;
  poster?: string;
  volume?: number;
  playbackRate?: number;
  muted?: boolean;
  isPlaying?: boolean;
  onPlay?: () => void;
  onPause?: () => void;
  onSeekRequest?: (time: number) => void;
  onTimeUpdate?: (currentTime: number, duration: number) => void;
  onVolumeChange?: (volume: number, muted: boolean) => void;
  onError?: (error: unknown) => void;
  onLoaded?: () => void;
  onLoadStart?: () => void;
}

export const UI_CONSTANTS = {
  BAR_HEIGHT: 36,
  HEADER_HEIGHT: 36,
  MOBILE_BREAKPOINT: 768,
  CORNER_PADDING: 20,
  ANIMATION_DURATION: 0.4,
} as const;